import { Component, OnInit, Input } from '@angular/core';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';

@Component({
    selector: 'activity-row-aktify-reengagement',
    templateUrl: './activity-row-aktify-reengagement.component.html',
    styleUrls: ['./activity-row-aktify-reengagement.component.scss'],
    standalone: false
})
export class ActivityRowAktifyReengagementComponent implements OnInit {
    @Input() activity: Activity;

    constructor() { }

    ngOnInit() {
    }

}
